const backgroundColor = {
  name: "background-color",
  path: "/background-color",
  title: "background-color",
  description: "Utilities for controlling an element's background color.",
  value: {
  "background-color": {
    "bg-color-inherit": "inherit",
    "bg-color-current": "currentColor",
    "bg-color-transparent": "transparent",
    "bg-color-[<value>]": "<value>", 
    "bg-color-black": "var(--color-black)",
    "bg-color-white": "var(--color-white)",
    "bg-color-red-50": "var(--color-red-50)",
    "bg-color-red-100": "var(--color-red-100)",
    "bg-color-red-200": "var(--color-red-200)",
    "bg-color-red-300": "var(--color-red-300)",
    "bg-color-red-400": "var(--color-red-400)",
    "bg-color-red-500": "var(--color-red-500)",
    "bg-color-red-600": "var(--color-red-600)",
    "bg-color-red-700": "var(--color-red-700)",
    "bg-color-red-800": "var(--color-red-800)",
    "bg-color-red-900": "var(--color-red-900)",
    "bg-color-orange-50": "var(--color-orange-50)",
    "bg-color-orange-100": "var(--color-orange-100)",
    "bg-color-orange-200": "var(--color-orange-200)",
    "bg-color-orange-300": "var(--color-orange-300)",
    "bg-color-orange-400": "var(--color-orange-400)",
    "bg-color-orange-500": "var(--color-orange-500)",
    "bg-color-orange-600": "var(--color-orange-600)",
    "bg-color-orange-700": "var(--color-orange-700)",
    "bg-color-orange-800": "var(--color-orange-800)",
    "bg-color-orange-900": "var(--color-orange-900)",
    "bg-color-amber-50": "var(--color-amber-50)",
    "bg-color-amber-100": "var(--color-amber-100)",
    "bg-color-amber-200": "var(--color-amber-200)",
    "bg-color-amber-300": "var(--color-amber-300)",
    "bg-color-amber-400": "var(--color-amber-400)",
    "bg-color-amber-500": "var(--color-amber-500)",
    "bg-color-amber-600": "var(--color-amber-600)",
    "bg-color-amber-700": "var(--color-amber-700)",
    "bg-color-amber-800": "var(--color-amber-800)",
    "bg-color-amber-900": "var(--color-amber-900)",
    "bg-color-yellow-50": "var(--color-yellow-50)",
    "bg-color-yellow-100": "var(--color-yellow-100)",
    "bg-color-yellow-200": "var(--color-yellow-200)",
    "bg-color-yellow-300": "var(--color-yellow-300)",
    "bg-color-yellow-400": "var(--color-yellow-400)",
    "bg-color-yellow-500": "var(--color-yellow-500)",
    "bg-color-yellow-600": "var(--color-yellow-600)",
    "bg-color-yellow-700": "var(--color-yellow-700)",
    "bg-color-yellow-800": "var(--color-yellow-800)",
    "bg-color-yellow-900": "var(--color-yellow-900)",
    "bg-color-lime-50": "var(--color-lime-50)",
    "bg-color-lime-100": "var(--color-lime-100)",
    "bg-color-lime-200": "var(--color-lime-200)",
    "bg-color-lime-300": "var(--color-lime-300)",
    "bg-color-lime-400": "var(--color-lime-400)",
    "bg-color-lime-500": "var(--color-lime-500)",
    "bg-color-lime-600": "var(--color-lime-600)",
    "bg-color-lime-700": "var(--color-lime-700)",
    "bg-color-lime-800": "var(--color-lime-800)",
    "bg-color-lime-900": "var(--color-lime-900)",
    "bg-color-green-50": "var(--color-green-50)",
    "bg-color-green-100": "var(--color-green-100)",
    "bg-color-green-200": "var(--color-green-200)",
    "bg-color-green-300": "var(--color-green-300)",
    "bg-color-green-400": "var(--color-green-400)",
    "bg-color-green-500": "var(--color-green-500)",
    "bg-color-green-600": "var(--color-green-600)",
    "bg-color-green-700": "var(--color-green-700)",
    "bg-color-green-800": "var(--color-green-800)",
    "bg-color-green-900": "var(--color-green-900)",
    "bg-color-emerald-50": "var(--color-emerald-50)",
    "bg-color-emerald-100": "var(--color-emerald-100)",
    "bg-color-emerald-200": "var(--color-emerald-200)",
    "bg-color-emerald-300": "var(--color-emerald-300)",
    "bg-color-emerald-400": "var(--color-emerald-400)",
    "bg-color-emerald-500": "var(--color-emerald-500)",
    "bg-color-emerald-600": "var(--color-emerald-600)",
    "bg-color-emerald-700": "var(--color-emerald-700)",
    "bg-color-emerald-800": "var(--color-emerald-800)",
    "bg-color-emerald-900": "var(--color-emerald-900)",
    "bg-color-teal-50": "var(--color-teal-50)",
    "bg-color-teal-100": "var(--color-teal-100)",
    "bg-color-teal-200": "var(--color-teal-200)",
    "bg-color-teal-300": "var(--color-teal-300)",
    "bg-color-teal-400": "var(--color-teal-400)",
    "bg-color-teal-500": "var(--color-teal-500)",
    "bg-color-teal-600": "var(--color-teal-600)",
    "bg-color-teal-700": "var(--color-teal-700)",
    "bg-color-teal-800": "var(--color-teal-800)",
    "bg-color-teal-900": "var(--color-teal-900)",
    "bg-color-cyan-50": "var(--color-cyan-50)",
    "bg-color-cyan-100": "var(--color-cyan-100)",
    "bg-color-cyan-200": "var(--color-cyan-200)",
    "bg-color-cyan-300": "var(--color-cyan-300)",
    "bg-color-cyan-400": "var(--color-cyan-400)",
    "bg-color-cyan-500": "var(--color-cyan-500)",
    "bg-color-cyan-600": "var(--color-cyan-600)",
    "bg-color-cyan-700": "var(--color-cyan-700)",
    "bg-color-cyan-800": "var(--color-cyan-800)",
    "bg-color-cyan-900": "var(--color-cyan-900)",
    "bg-color-sky-50": "var(--color-sky-50)",
    "bg-color-sky-100": "var(--color-sky-100)",
    "bg-color-sky-200": "var(--color-sky-200)",
    "bg-color-sky-300": "var(--color-sky-300)",
    "bg-color-sky-400": "var(--color-sky-400)",
    "bg-color-sky-500": "var(--color-sky-500)",
    "bg-color-sky-600": "var(--color-sky-600)",
    "bg-color-sky-700": "var(--color-sky-700)",
    "bg-color-sky-800": "var(--color-sky-800)",
    "bg-color-sky-900": "var(--color-sky-900)",
    "bg-color-blue-50": "var(--color-blue-50)",
    "bg-color-blue-100": "var(--color-blue-100)",
    "bg-color-blue-200": "var(--color-blue-200)",
    "bg-color-blue-300": "var(--color-blue-300)",
    "bg-color-blue-400": "var(--color-blue-400)",
    "bg-color-blue-500": "var(--color-blue-500)",
    "bg-color-blue-600": "var(--color-blue-600)",
    "bg-color-blue-700": "var(--color-blue-700)",
    "bg-color-blue-800": "var(--color-blue-800)",
    "bg-color-blue-900": "var(--color-blue-900)",
    "bg-color-indigo-50": "var(--color-indigo-50)",
    "bg-color-indigo-100": "var(--color-indigo-100)",
    "bg-color-indigo-200": "var(--color-indigo-200)",
    "bg-color-indigo-300": "var(--color-indigo-300)",
    "bg-color-indigo-400": "var(--color-indigo-400)",
    "bg-color-indigo-500": "var(--color-indigo-500)",
    "bg-color-indigo-600": "var(--color-indigo-600)",
    "bg-color-indigo-700": "var(--color-indigo-700)",
    "bg-color-indigo-800": "var(--color-indigo-800)",
    "bg-color-indigo-900": "var(--color-indigo-900)",
    "bg-color-violet-50": "var(--color-violet-50)",
    "bg-color-violet-100": "var(--color-violet-100)",
    "bg-color-violet-200": "var(--color-violet-200)",
    "bg-color-violet-300": "var(--color-violet-300)",
    "bg-color-violet-400": "var(--color-violet-400)",
    "bg-color-violet-500": "var(--color-violet-500)",
    "bg-color-violet-600": "var(--color-violet-600)",
    "bg-color-violet-700": "var(--color-violet-700)",
    "bg-color-violet-800": "var(--color-violet-800)",
    "bg-color-violet-900": "var(--color-violet-900)",
    "bg-color-purple-50": "var(--color-purple-50)",
    "bg-color-purple-100": "var(--color-purple-100)",
    "bg-color-purple-200": "var(--color-purple-200)",
    "bg-color-purple-300": "var(--color-purple-300)",
    "bg-color-purple-400": "var(--color-purple-400)",
    "bg-color-purple-500": "var(--color-purple-500)",
    "bg-color-purple-600": "var(--color-purple-600)",
    "bg-color-purple-700": "var(--color-purple-700)",
    "bg-color-purple-800": "var(--color-purple-800)",
    "bg-color-purple-900": "var(--color-purple-900)",
    "bg-color-fuchsia-50": "var(--color-fuchsia-50)",
    "bg-color-fuchsia-100": "var(--color-fuchsia-100)",
    "bg-color-fuchsia-200": "var(--color-fuchsia-200)",
    "bg-color-fuchsia-300": "var(--color-fuchsia-300)",
    "bg-color-fuchsia-400": "var(--color-fuchsia-400)",
    "bg-color-fuchsia-500": "var(--color-fuchsia-500)",
    "bg-color-fuchsia-600": "var(--color-fuchsia-600)",
    "bg-color-fuchsia-700": "var(--color-fuchsia-700)",
    "bg-color-fuchsia-800": "var(--color-fuchsia-800)",
    "bg-color-fuchsia-900": "var(--color-fuchsia-900)",
    "bg-color-pink-50": "var(--color-pink-50)",
    "bg-color-pink-100": "var(--color-pink-100)",
    "bg-color-pink-200": "var(--color-pink-200)",
    "bg-color-pink-300": "var(--color-pink-300)",
    "bg-color-pink-400": "var(--color-pink-400)",
    "bg-color-pink-500": "var(--color-pink-500)",
    "bg-color-pink-600": "var(--color-pink-600)",
    "bg-color-pink-700": "var(--color-pink-700)",
    "bg-color-pink-800": "var(--color-pink-800)",
    "bg-color-pink-900": "var(--color-pink-900)",
    "bg-color-rose-50": "var(--color-rose-50)",
    "bg-color-rose-100": "var(--color-rose-100)",
    "bg-color-rose-200": "var(--color-rose-200)",
    "bg-color-rose-300": "var(--color-rose-300)",
    "bg-color-rose-400": "var(--color-rose-400)",
    "bg-color-rose-500": "var(--color-rose-500)",
    "bg-color-rose-600": "var(--color-rose-600)",
    "bg-color-rose-700": "var(--color-rose-700)",
    "bg-color-rose-800": "var(--color-rose-800)",
    "bg-color-rose-900": "var(--color-rose-900)",
    "bg-color-slate-50": "var(--color-slate-50)",
    "bg-color-slate-100": "var(--color-slate-100)",
    "bg-color-slate-200": "var(--color-slate-200)",
    "bg-color-slate-300": "var(--color-slate-300)",
    "bg-color-slate-400": "var(--color-slate-400)",
    "bg-color-slate-500": "var(--color-slate-500)",
    "bg-color-slate-600": "var(--color-slate-600)",
    "bg-color-slate-700": "var(--color-slate-700)",
    "bg-color-slate-800": "var(--color-slate-800)",
    "bg-color-slate-900": "var(--color-slate-900)",
    "bg-color-gray-50": "var(--color-gray-50)",
    "bg-color-gray-100": "var(--color-gray-100)",
    "bg-color-gray-200": "var(--color-gray-200)",
    "bg-color-gray-300": "var(--color-gray-300)",
    "bg-color-gray-400": "var(--color-gray-400)",
    "bg-color-gray-500": "var(--color-gray-500)",
    "bg-color-gray-600": "var(--color-gray-600)",
    "bg-color-gray-700": "var(--color-gray-700)",
    "bg-color-gray-800": "var(--color-gray-800)",
    "bg-color-gray-900": "var(--color-gray-900)",
    "bg-color-zinc-50": "var(--color-zinc-50)",
    "bg-color-zinc-100": "var(--color-zinc-100)",
    "bg-color-zinc-200": "var(--color-zinc-200)",
    "bg-color-zinc-300": "var(--color-zinc-300)",
    "bg-color-zinc-400": "var(--color-zinc-400)",
    "bg-color-zinc-500": "var(--color-zinc-500)",
    "bg-color-zinc-600": "var(--color-zinc-600)",
    "bg-color-zinc-700": "var(--color-zinc-700)",
    "bg-color-zinc-800": "var(--color-zinc-800)",
    "bg-color-zinc-900": "var(--color-zinc-900)",
    "bg-color-neutral-50": "var(--color-neutral-50)",
    "bg-color-neutral-100": "var(--color-neutral-100)",
    "bg-color-neutral-200": "var(--color-neutral-200)",
    "bg-color-neutral-300": "var(--color-neutral-300)",
    "bg-color-neutral-400": "var(--color-neutral-400)",
    "bg-color-neutral-500": "var(--color-neutral-500)",
    "bg-color-neutral-600": "var(--color-neutral-600)",
    "bg-color-neutral-700": "var(--color-neutral-700)",
    "bg-color-neutral-800": "var(--color-neutral-800)",
    "bg-color-neutral-900": "var(--color-neutral-900)",
    "bg-color-stone-50": "var(--color-stone-50)",
    "bg-color-stone-100": "var(--color-stone-100)",
    "bg-color-stone-200": "var(--color-stone-200)",
    "bg-color-stone-300": "var(--color-stone-300)",
    "bg-color-stone-400": "var(--color-stone-400)",
    "bg-color-stone-500": "var(--color-stone-500)",
    "bg-color-stone-600": "var(--color-stone-600)",
    "bg-color-stone-700": "var(--color-stone-700)",
    "bg-color-stone-800": "var(--color-stone-800)",
    "bg-color-stone-900": "var(--color-stone-900)"
  }
},
  exampleData: [
    {
      example: {
        code: `
<button class="bg-color-blue-500 ...">Button A</button>
<button class="bg-color-cyan-500 ...">Button B</button>
<button class="bg-color-pink-500 ...">Button C</button>
<button class="bg-color-[#92c448] ...">Button D</button>        `
      }
    },
    {
      example: {
        code: `
<button class="bg-color-sky-500/100 ..."></button>
<button class="bg-color-sky-500/75 ..."></button>
<button class="bg-color-sky-500/50 ..."></button>        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:bg-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">bg-color-*</code> utilities to control background-color. Supports all palette colors, <code>inherit</code>, <code>currentColor</code>, and <code>transparent</code>.
      </p>
      <div class="grid grid-columns-1 gap-4 text-sm text-color-white sm:grid-columns-4">
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-3 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-color-blue-500</p>
            <button type="button" tabindex="-1" class="rounded-md bg-color-blue-500 px-4 py-2 text-sm font-semibold text-color-white opacity-100 focus:outline-none">Button A</button>
        </div>
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-3 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-color-blue-500</p>
            <button type="button" tabindex="-1" class="rounded-md bg-color-cyan-500 px-4 py-2 text-sm font-semibold text-color-white opacity-100 focus:outline-none">Button B</button>
        </div>
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-3 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-color-blue-500</p>
            <button type="button" tabindex="-1" class="rounded-md bg-color-pink-500 px-4 py-2 text-sm font-semibold text-color-white opacity-100 focus:outline-none">Button C</button>
        </div>
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-3 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-color-[#92c448]</p>
            <button type="button" tabindex="-1" class="rounded-md bg-color-[#92c448] px-4 py-2 text-sm font-semibold text-color-white opacity-100 focus:outline-none">Button D</button>
        </div>
    </div>
    `
  },
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:bg-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">Changing the opacity</code> Use the color opacity modifier to control the opacity of an element's background color:
      </p>
      <div class="grid grid-columns-1 gap-4 text-sm text-color-white sm:grid-columns-3">
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-3 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-color-sky-500/100</p>
            <button type="button" tabindex="-1" class="rounded-md bg-color-sky-500/100 px-4 py-2 text-sm font-semibold text-color-white opacity-100 focus:outline-none">Button A</button>
        </div>
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-3 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-color-sky-500/75</p>
            <button type="button" tabindex="-1" class="rounded-md bg-color-sky-500/75 px-4 py-2 text-sm font-semibold text-color-white opacity-100 focus:outline-none">Button B</button>
        </div>
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-3 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-color-sky-500/50</p>
            <button type="button" tabindex="-1" class="rounded-md bg-color-sky-500/50 px-4 py-2 text-sm font-semibold text-color-white opacity-100 focus:outline-none">Button C</button>
        </div>
        
    </div>
    `
  },
]
}
export default backgroundColor;

<div class="sr-only">
<div class="grid grid-columns-1 gap-4 text-sm text-color-white sm:grid-columns-3 bg-color-[#92c448] sm:grid-columns-4 bg-color-sky-500/100 bg-color-sky-500/50 bg-color-sky-500/75">
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-3 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-blue-500</p>
            <button type="button" tabindex="-1" class="rounded-md bg-color-blue-500 px-4 py-2 text-sm font-semibold text-color-white opacity-100 focus:outline-none">Button A</button>
        </div>
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-3 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-blue-500</p>
            <button type="button" tabindex="-1" class="rounded-md bg-color-cyan-500 px-4 py-2 text-sm font-semibold text-color-white opacity-100 focus:outline-none">Button B</button>
        </div>
        <div class="flex shrink-0 flex-col items-center">
            <p class="mb-3 text-center font-mono text-xs font-medium text-color-gray-500 dark:text-color-gray-400">bg-blue-500</p>
            <button type="button" tabindex="-1" class="rounded-md bg-color-pink-500 px-4 py-2 text-sm font-semibold text-color-white opacity-100 focus:outline-none">Button C</button>
        </div>
        
    </div>
</div>